export default __webpack_public_path__ + "static/media/chain-link-fencing-500x500.b52f4190.jpeg";